
import React from "react";
import { Col, Container, Row} from "react-bootstrap";



function StrategyConfigView(params) {
    const strategyConfig = params.config != null && params.config.strategyConfig != null ? params.config.strategyConfig : {name:'unknown'}
    return <div className="press-grid">
        <Container>
            <Row>
                <Col>Strategy</Col>
                <Col>Type</Col>
                <Col>Stop Amt</Col>
                <Col>Tke Profit Amt</Col>
                <Col>Trail Amt</Col>
                <Col>Trail Adjust</Col>
                <Col>Adjust Target</Col>
            </Row>
            <Row>
                <Col>{strategyConfig.name}</Col>
                <Col>{strategyConfig.type}</Col>
                <Col>{strategyConfig.stopLossAmount}</Col>
                <Col>{strategyConfig.takeProfitAmount}</Col>
                <Col>{strategyConfig.trailAmount}</Col>
                <Col>{strategyConfig.trailAdjustAmount}</Col>
                <Col>{strategyConfig.trailAdjustTarget}</Col>
            </Row>
        </Container>
    </div>;
}


export {StrategyConfigView}
